module.exports = __webpack_public_path__ + "e60d75676a54984d2628f889201d4a44.eot";


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/content/fonts/BebasNeue-Regular.eot
// module id = 194
// module chunks = 1